import * as React from 'react';
import { useEffect } from 'react';

/** @hook
 * Creates callbacks to query the window.
 * @returns {number}
 */
export const useWindow = () => {
    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return windowWidth;
};
